import { render, staticRenderFns } from "./leadList1.vue?vue&type=template&id=18943de4&scoped=true"
import script from "./leadList1.vue?vue&type=script&lang=js"
export * from "./leadList1.vue?vue&type=script&lang=js"
import style0 from "./leadList1.vue?vue&type=style&index=0&id=18943de4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18943de4",
  null
  
)

export default component.exports